import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import searchIcon from '../../images/search-icon.svg';
import './SearchInputButton.scss';
import ArrowCircledIcon from '../../images/arrow-circled-icon.svg';
import closeIcon from '../../images/close-icon.svg';

const SearchInputButton = ({
  isSearching,
  onFocus,
  onChange,
  value = '',
  placeholder = 'Search for deals',
  onClose,
  autoFocus = false,
  onClearSearch,
  readOnly = false,
}) => {
  const [focused, setFocused] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);

  const handleFocus = () => {
    setFocused(true);
    if (typeof onFocus === 'function') {
      onFocus();
    }
  };

  const handleBlur = () => {
    setFocused(false);
  };

  return (
    <div className="SearchInputButton__wrapper">
      {isSearching && (
        <button
          className="SearchInputButton__content-header-back"
          aria-label="back"
          type="button"
          onClick={onClose}
        >
          <img className="SearchInputButton__content-header-back-icon" src={ArrowCircledIcon} alt="arrow-back" />
        </button>
      )}
      <div className={classNames('SearchInputButton__input-container', { focused })}>
        <img className="SearchInputButton__search-icon" src={searchIcon} alt="search-icon" />
        <input
          ref={inputRef}
          className="SearchInputButton__input"
          placeholder={focused ? '' : placeholder}
          value={value}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onChange={onChange}
          readOnly={readOnly}
        />
        {isSearching && value.length > 0 && (
          <div
            onClick={() => {
              if (typeof onClearSearch === 'function') onClearSearch();
              if (inputRef.current) inputRef.current.focus();
            }}
            type="button"
            role="button"
            tabIndex={0}
            onKeyDown={onClearSearch}
            className="SearchInputButton__close-icon-container"
          >
            <img
              className="SearchInputButton__close-icon"
              src={closeIcon}
              alt="close-icon"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchInputButton;
